module.exports = __webpack_public_path__ + "img/lines-double-start.da91f434.png";